
import Container from '@mui/material/Container';
// import Stack from '@mui/material/Stack';
// import Divider from '@mui/material/Divider';
// import Slider from '@mui/material/Slider';
// import styled from 'styled-components';


import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card
} from '../../components';

import PurchaseInput from '../Components/PurchaseInput'

import {
    useSilver
} from '../../context/silver'

import {
    useSwap
} from '../../hook/silver/uesSilver'

import {
    ShortAddress,
    EtherToInt
} from '../../ethers/e'

import { useTranslation } from 'react-i18next';


function BuyUSDG({balance}) {
    const {
        button,
        inputAmount
    } = useSwap(true)
    const {t} = useTranslation()
    return (
        <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
            <WhiteSpace size={.8}/>
            <TextXL>{t('Buy')} USDG</TextXL>
            <WhiteSpace />
            <PurchaseInput 
                slider
                input={inputAmount}
                balance={{
                    token: 'USDT',
                    amount: balance
                }}
            />
            <WhiteSpace size={.2}/>
            <TextS color='2'>{t('Available')} <TextS>{EtherToInt(inputAmount.value)}</TextS> USDG</TextS>
            <WhiteSpace />
            <Button style={{width:'100%'}} {...button}/>
        </Card>
    )
}

function SellUSDG({balance}) {
    const {
        button,
        inputAmount
    } = useSwap(false)
    const {t} = useTranslation()
    return (
        <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
            <TextXL>{t('Sell')} USDG</TextXL>
            <WhiteSpace />
            <PurchaseInput
                slider
                input={inputAmount}
                balance={{
                    token: 'USDG',
                    amount: balance
                }}
            />
            <WhiteSpace size={.2}/>
            <TextS color='2'>{t('Available')} <TextS>{EtherToInt((inputAmount.value * (1 - 0.099)).toFixed(3)*1)}</TextS> USDT</TextS>
            <WhiteSpace size='0'/>
            <TextS color='2'>{t('Change fee')} <TextS>{EtherToInt((inputAmount.value * 0.099).toFixed(3)*1)}</TextS> USDT</TextS>
            <WhiteSpace />
            <Button type='c' style={{width:'100%'}} {...button}/>
        </Card>
    )
}

function Index() {
    const {
        usdgBalance,
        usdtBalance,
    } = useSilver()
    const {t} = useTranslation()
    
    return (
        <Container>
            <WhiteSpace size={.4}/>
            <Title src='/icon/swaptitle.png' shadow='unset'>
                <TextXL style={{lineHeight: '22px'}} >{t('Sawp')}<TextM style={{marginLeft: '10px'}} color='2'>USDT {'<->'} USDG</TextM></TextXL>
            </Title>
            <BuyUSDG balance={usdtBalance}/>
            <WhiteSpace />
            <SellUSDG balance={usdgBalance} />
        </Container>
    )
}

export default Index